export enum DateType {
    TO = 'to',
    FROM = 'from',
}

export enum TransactionsViewType {
    DEPOSITS = 'deposits',
    WITHDRAWALS = 'withdrawals',
    GAMEPLAY = 'gameplay',
    SPORTS = 'sports',
}

export enum TransactionsOperationType {
    CREDIT = 'Credit',
    DEBIT = 'Debit',
}

export enum TransactionsMediatorType {
    MONETARY = 'monetary',
    CASINO = 'casino',
    SPORTS = 'sports',
}

export enum TransactionsStatus {
    COMPLETED = 'Completed',
    PENDINGAUTHORIZATION = 'PendingAuthorization',
}

export enum BetType {
    System = 'System',
    Combined = 'Combined',
    Single = 'Single',
}

export interface IAdditionalProperties {
    Casino?: {
        ReportingCategory: string;
        JurisdictionCategory: string;
        GameName: string;
        GameExternalId: string;
    };
    Sports?: {
        Transaction: {
            SettlementType?: string;
            SettlementStatus?: string;
            BetType?: BetType;
            BetStatus?: string;
        };
        Selections?: {
            SportName: string;
            SelectionName: string;
            RegionName: string;
            Reference: string;
            Odds: string;
            MarketName: string;
            IsLive: string;
            EventStartDate: string;
            EventName: string;
            EventId: string;
            EventEndDate: string;
            CompetitionName: string;
        }[];
    };
    Payments?: {
        Transaction: {
            PaymentMethod: string;
            PaymentIntegrationTransactionId: string;
            Description: string;
        };
    };
    CustomTransactionExternalId: string;
}
